import { Component } from '@angular/core';

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: `
    
    <div class="socials">
      <a href="https://github.com/mcwebdev" target="_blank" class="ion ion-social-github"></a>
      <a href="https://www.linkedin.com/in/mattcharlton/" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
    standalone: false
})
export class FooterComponent {
}
